import { Button, ButtonsGroup, Modal, ModalProps, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { useInitiateOpenBankingConnection } from '../../../../hooks/useInitiateOpenBankingConnection'

export const BankAccountOrphanedModal = ({ ...modalProps }: ModalProps): ReactElement => {
  const { t } = useTranslation()
  const { connectToOpenBanking, isProcessing } = useInitiateOpenBankingConnection()

  const handleClose = () => {
    connectToOpenBanking()
  }

  return (
    <Modal size="s" {...modalProps}>
      <Modal.Header>
        <Text variant="h2">{t('bank_connection.bank_account_orphaned.title')}</Text>
      </Modal.Header>
      <Modal.Body>
        <Text>
          <Trans i18nKey="bank_connection.bank_account_orphaned.text" />
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <ButtonsGroup>
          <Button onClick={handleClose} variant="filled" loading={isProcessing}>
            {t('renew_connection')}
          </Button>
        </ButtonsGroup>
      </Modal.Footer>
    </Modal>
  )
}
